import { orderBy } from 'lodash';

interface BaseSession {
  startDateTime: string;
  duration: number;
}

type OrderBy = 'asc' | 'desc';

export const getSortedSessionsByStartAndDuration = <T extends BaseSession>(
  sessions: T[],
  timeOrderBy: OrderBy = 'asc',
  durationOrderBy: OrderBy = 'asc',
) => {
  return orderBy<T>(
    sessions,
    ['startDateTime', 'duration'],
    [timeOrderBy, durationOrderBy],
  );
};
